export const onEnter = (event, callback) => {
  if (event.key === 'Enter') {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/utilities/accessibility/onEnter.js